import React, { useEffect, useState, useCallback } from 'react';


const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

const ObserverDimensions = () => {
    const [dimensions, setDimensions] = useState({ height: 0, width: 0 });

    const sendDimensionsToParent = useCallback(() => {
        window.parent.postMessage(dimensions, '*');
    }, [dimensions]);

    const handleResize = useCallback(debounce(() => {
        const newHeight = document.body.scrollHeight;
        const newWidth = document.body.scrollWidth;

        if (newHeight !== dimensions.height || newWidth !== dimensions.width) {
            setDimensions({ height: newHeight, width: newWidth });
        }
    }, 100), [dimensions]);

    useEffect(() => {
        const observer = new MutationObserver(() => {
            handleResize();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true,
        });

        window.onload = handleResize;
        window.onresize = handleResize;

        return () => {
            window.onload = null;
            window.onresize = null;
            observer.disconnect();
        };
    }, [handleResize]);

    useEffect(() => {
        sendDimensionsToParent();
    }, [dimensions, sendDimensionsToParent]);

    return null;
};

export default ObserverDimensions;
